// src/components/TeamForm.js
import React from "react";
import {
  FormContainer,
  FormInnerContainer,
  SubmitButton,
  CancelButton,
  Input,
  Label,
  Select,
  Checkbox,
  Row,
  Column
} from "../styles/StyledComponents";

const TeamForm = ({
  visible,
  member,
  onChange,
  onSubmit,
  onCancel,
  isEditing
}) => {
  if (!visible) return null; // Certifique-se de que o modal só renderiza se `visible` for true

  return (
    <FormContainer visible={visible}>
      <FormInnerContainer>
        <form onSubmit={onSubmit}>
          <Row columns={12}>
            <Column cols={12}>
              <h2>
                {isEditing ? "Editar usuário" : "Novo usuário"}
              </h2>
            </Column>
          </Row>
          <Row columns={12} mt={-32}>
            <Column cols={12}>
              <p>Complete os campos abaixo para criar ou editar um usuário.</p>
            </Column>
          </Row>

          <Row columns={12} mt={64}>
            <Column cols={6}>
              <Label>ID do Empregado</Label>
              <Input
                type="text"
                name="employeeId"
                value={member.employeeId}
                onChange={onChange}
                required
              />
            </Column>
            <Column cols={6}>
              <Label>Perfil</Label>
              <Select
                name="profile"
                value={member.profile}
                onChange={onChange}
                required
              >
                <option value="Admin">Admin</option>
                <option value="Usuario">Usuário</option>
                <option value="Tecnico">Técnico</option>
                <option value="Supervisor">Supervisor</option>
              </Select>
            </Column>
          </Row>

          <Row columns={12}>
            <Column cols={6}>
              <Label>Nome</Label>
              <Input
                type="text"
                name="name"
                value={member.name}
                onChange={onChange}
                required
              />
            </Column>
            <Column cols={6}>
              <Label>Email</Label>
              <Input
                type="email"
                name="email"
                value={member.email}
                onChange={onChange}
                autoComplete="off"
                required
              />
            </Column>
          </Row>

          <Row columns={12}>
            <Column cols={6}>
              <Label>Telefone</Label>
              <Input
                type="text"
                name="telephone"
                value={member.telephone}
                onChange={onChange}
                required
              />
            </Column>
          </Row>

          <Row columns={12} mt={16}>
            <Column cols={3}>
              <Label>
                <Checkbox
                  type="checkbox"
                  name="status"
                  checked={member.status}
                  onChange={onChange}
                />
                Status Ativo.
              </Label>
            </Column>
            <Column cols={8}>
              <Label>
                <Checkbox
                  type="checkbox"
                  name="firstAccess"
                  checked={member.firstAccess}
                  onChange={onChange}
                />
                Redefinir Senha ao realizar acesso.
              </Label>
            </Column>
          </Row>

          <Row columns={12} mt={32}>
            <Column cols={2}>
              <SubmitButton type="submit">Salvar</SubmitButton>
            </Column>
            <Column cols={2}>
              <CancelButton type="button" onClick={onCancel}>
                Cancelar
              </CancelButton>
            </Column>
          </Row>
        </form>
      </FormInnerContainer>
    </FormContainer>
  );
};

export default TeamForm;
